import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import { BgImage } from "gbimage-bridge"

const defaultBackground = "biography"
const FullBackground = ({ children, page }) => {
  const images = useStaticQuery(
    graphql`
      {
        medium: file(relativePath: { eq: "backgrounds/portrait_1.jpg" }) {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: FULL_WIDTH
              placeholder: BLURRED
            )
          }
        }
        small: file(relativePath: { eq: "backgrounds/portrait_2.jpg" }) {
          childImageSharp {
            gatsbyImageData(
              # width: 769
              quality: 100
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
        biography: file(relativePath: { eq: "backgrounds/01.jpg" }) {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
        repertoire: file(relativePath: { eq: "backgrounds/02.jpg" }) {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
        gallery: file(relativePath: { eq: "backgrounds/03.jpg" }) {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
        contact: file(relativePath: { eq: "backgrounds/04.jpg" }) {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
      }
    `
  )

  // Art-Direction Array
  const backgroundArtDirectionStack = [
    getImage(images.small),
    {
      ...getImage(images.medium),
      media: `(min-width: 769px)`,
    },
  ]

  const BackgroundImage = page =>
    page === "home"
      ? backgroundArtDirectionStack
      : [getImage(images[page]) || getImage(images[defaultBackground])]

  return (
    <BgImage
      Tag="section"
      className="full_background"
      image={BackgroundImage(page)}
      backgroundColor={`#040e18`}
      // title="Art-Directed Fullscreen Background"
      id="adfullscreenbg"
      role="img"
      aria-label="Art-Directed Fullscreen Background"
      preserveStackingContext={true}
    >
      {children}
    </BgImage>
  )
}

export default FullBackground
